import { IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useCBBanner } from './hooks';

import logoRappi from 'assets/images/logos/logo_rappi_square.png';
import makeClasses from './CBBanner.style';

// Chrome Browser Banner (ChromeBrowserBanner)
export function CBBanner() {
  const { lang, isShowed, handleCTA, handleClose } = useCBBanner();

  const _classes = makeClasses();

  if (!isShowed) return null;
  return (
    <div role='alert' aria-live='polite' className={_classes.banner}>
      <img alt='logo-rappi' src={logoRappi} className={_classes.img} />

      <p
        className={_classes.description}
        dangerouslySetInnerHTML={{ __html: lang.description }}
      />

      <Button variant='text' onClick={handleCTA} className={_classes.cta}>
        {lang.cta}
      </Button>

      <IconButton size='small' aria-label='Close' onClick={handleClose}>
        <CloseIcon className={_classes.closeIcon} />
      </IconButton>
    </div>
  );
}
